import axios from 'axios'
import { getBaseUrlForApi, http } from '@/utils/api'
import Sentry from '@/core/sentry'
import type { Locale } from '@/utils/locale'
import { isWhitelistError } from '@/utils/api/whitelist'

export type ValidationResponse = {
  isMinLengthValid: true
  isMaxLengthValid: true
  hasDigitValid: true
  hasLowerCaseValid: true
  hasUpperCaseValid: true
  hasSpecialCharacterValid: true
  hasOnlyAllowedCharactersValid: true
}

// ## VALIDATIONS
export async function validate(params: any) {
  const url = 'users/validate'

  try {
    const { data } = await http.post<ValidationResponse>(url, params)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: {
        error,
      },
    }
  }
}

export type MaintenanceMessage = {
  alert_type: 'info' | 'warning' | 'error' | 'success'
  translation_key: string
}

export async function loadMaintenanceMessages() {
  try {
    const url = 'maintenance/messages'

    const { data } = await http.get<MaintenanceMessage[]>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function loadMaintenanceTranslations() {
  const instance = axios.create({
    baseURL: getBaseUrlForApi(),
  })

  const url = 'translations/maintenance_notifications'

  try {
    const { data } =
      await instance.get<Record<Locale, Record<string, string>>>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function loadProvisioningTemplates() {
  try {
    const { data } = await http.get('/provisioning-templates', {})

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function loadTranslations() {
  const instance = axios.create({
    baseURL: getBaseUrlForApi(),
  })

  const url = 'translations/cta'

  try {
    const { data } =
      await instance.get<Record<Locale, Record<string, string>>>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function loadNavigationTranslations() {
  const instance = axios.create({
    baseURL: getBaseUrlForApi(),
  })

  const url = 'translations/navigation'

  try {
    const { data } =
      await instance.get<Record<Locale, Record<string, string>>>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
